import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import WeeklyReport from './WeeklyReport';
import { useHeroSequence } from '../hooks/useHeroSequence';
import { CITIES, HEADLINE, HERO_NOTE, SUBHEAD } from '../data/site';
import { track, EVENTS } from '../utils/analytics';

const EASE = [0.16, 1, 0.3, 1] as const;

const Hero: React.FC = () => {
  const reduced = Boolean(useReducedMotion());
  const { heroRef, mapDrawn, pingsLanded, reportStart, calloutIn } =
    useHeroSequence(reduced);

  const rise = (delay: number) =>
    reduced
      ? {}
      : {
          initial: { opacity: 0, y: 16 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.5, ease: EASE, delay },
        };

  return (
    <section className="hero" ref={heroRef}>
      <div className="shell hero__inner">
        <div className="hero__copy">
          <h1 className="display">{HEADLINE}</h1>

          <p className="hero__sub">{SUBHEAD}</p>

          <motion.p className="hero__note" {...rise(0.12)}>
            {HERO_NOTE}
          </motion.p>

          <motion.div className="hero__actions" {...rise(0.16)}>
            <Link
              to="/contact"
              className="button button--primary"
              onClick={() =>
                track(EVENTS.ctaClicked, { location: 'hero', label: 'Get a free audit' })
              }
            >
              Get a free audit
            </Link>
            <a
              href="#ads"
              className="button button--quiet"
              onClick={() =>
                track(EVENTS.ctaClicked, { location: 'hero', label: 'See the ads' })
              }
            >
              See the ads
              <span className="button__glyph" aria-hidden="true">
                ↓
              </span>
            </a>
          </motion.div>

          <motion.p className="hero__meta" {...rise(0.24)}>
            <span>{CITIES}</span>
          </motion.p>
        </div>

        <motion.div
          className="hero__stage"
          {...(reduced
            ? {}
            : {
                initial: { opacity: 0, y: 24 },
                animate: { opacity: 1, y: 0 },
                transition: { duration: 0.64, ease: EASE, delay: 0.16 },
              })}
        >
          <div className="hero-report">
            <WeeklyReport
              leadCount={pingsLanded}
              sequenceStart={reportStart}
              showMap
              mapDrawIn={mapDrawn}
            />
            <div className={`hero-report__assistant${calloutIn ? ' hero-report__assistant--in' : ''}`}>
              <img src="/arceus/arceus-bust-greet.webp" alt="" width={72} height={72} fetchPriority="high" />
              <p><b>Arceus found the pattern.</b><span>14 leads came from one Instagram ad.</span></p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default React.memo(Hero);
